import { Fingerprint, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useScanner } from "@/context/ScannerContext";
import { SCANNER_STATE } from "@/lib/mantra";

const COLORS = {
  [SCANNER_STATE.CONNECTED]: "bg-emerald-100 text-emerald-800 border-emerald-200",
  [SCANNER_STATE.READY]: "bg-emerald-100 text-emerald-800 border-emerald-200",
  [SCANNER_STATE.SUCCESS]: "bg-emerald-100 text-emerald-800 border-emerald-200",
  [SCANNER_STATE.CAPTURING]: "bg-sky-100 text-sky-800 border-sky-200",
  [SCANNER_STATE.BUSY]: "bg-amber-100 text-amber-800 border-amber-200",
};

export function StatePill({ state, testid = "scanner-state" }) {
  return <span data-testid={testid} className={`inline-flex items-center gap-1.5 text-xs font-semibold rounded-full border px-2.5 py-1 ${COLORS[state] || "bg-red-50 text-red-700 border-red-200"}`}><Fingerprint className="w-3.5 h-3.5" />{state}</span>;
}

export default function ScannerStatus({ compact = false }) {
  const { status, refresh, settings } = useScanner();
  return (
    <div data-testid="scanner-status" className={`flex items-center gap-3 ${compact ? "" : "bg-white rounded-2xl border border-slate-200 p-4"}`}>
      <StatePill state={status.checking ? "Checking…" : status.state} />
      <div className="flex-1 min-w-0">
        <p className="text-xs text-slate-600 truncate" data-testid="scanner-message">{status.message}</p>
        {!compact && <p className="text-[11px] text-slate-400">{settings?.device_model || "Mantra MFS110 L1"} · mode: {status.mode || "none"}</p>}
      </div>
      <Button size="sm" variant="outline" data-testid="scanner-refresh" onClick={() => refresh()} disabled={status.checking} className="rounded-lg h-8">
        <RefreshCw className={`w-3.5 h-3.5 ${status.checking ? "animate-spin" : ""}`} />
      </Button>
    </div>
  );
}
